export default __webpack_public_path__ + "static/media/18.f9410262.jpg";